import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'status',
})
export class StatusPipe implements PipeTransform {

  transform(type: string, ...args: unknown[]): string {
      switch (type) {
          case 'new':
              return 'Neu';
          case 'in_progress':
              return 'In Bearbeitung';
          case 'done':
              return 'Erledigt';
          case 'cancelled':
              return 'Abgesagt';
          default:
              return type;
      }
  }

}
